import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin: 10px 0 18px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  box-shadow: ", ";\n  display: flex;\n  height: 58px;\n  justify-content: center;\n  width: 58px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  opacity: ", ";\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-radius: inherit;\n  left: 50%;\n  max-width: ", "px;\n  min-width: 100%;\n  position: absolute;\n  text-align: center; /* to align alt=\"\" text */\n  top: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      min-height: 134px;\n      padding: 12px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      &::after {\n        display: none;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  min-height: 60px;\n  padding-top: 75%; /* 4:3 Aspect Ratio */\n  position: relative;\n  width: 100%;\n\n  /* stylelint-disable-next-line */\n  ", "\n\n  /* stylelint-disable-next-line */\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { ellipsis, rgba } from 'polished';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color, property } from '@scp/ui-shared/theme/variables';
import { ClearedButton } from '@scp/ui-shared/theme/resets';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { Subtext, Paragraph } from '@scp/ui-shared/components/typography';
import { Loader } from '@scp/ui-shared/components/Loader';
import { FileIcon } from './FileIcon';
import { withHipaaConfirm } from './withHipaaConfirm';
import { isImage, parseFileSize } from './utils';
import { HIPAA_DOWNLOAD_WARNING_TEXT } from './constants';
var TEXT = {
  CANCEL_UPLOAD_TITLE: 'Tap to cancel the upload',
  IMAGE_CLICK_TITLE: 'Tap to preview large image',
  DOWNLOAD_TITLE: 'Tap to download attachment'
};
var MAX_THUMBNAIL_WIDTH = 600;
var WrapperComponent = withRippleEffect(ClearedButton);
var Wrapper = styled(WrapperComponent).attrs({
  type: 'button'
})(_templateObject(), color.palette.white, function (props) {
  return props.disabledRipple && css(_templateObject2());
}, function (props) {
  return props.isDocument && css(_templateObject3());
});
var Image = styled.img(_templateObject4(), MAX_THUMBNAIL_WIDTH);
var LoaderWrapper = styled.span(_templateObject5(), function (props) {
  return props.visible ? 1 : 0;
});
var CancelIconWrapper = styled.span(_templateObject6(), rgba(color.palette.white, 0.85), property.boxShadow);
var FileIconWrapper = styled.span(_templateObject7());
var Title = styled(Paragraph).attrs({
  secondary: true,
  bold: true,
  as: 'span'
})(_templateObject8(), ellipsis());
export var FilePreview = withHipaaConfirm({
  confirmText: HIPAA_DOWNLOAD_WARNING_TEXT
})(function (_ref) {
  var fileMeta = _ref.fileMeta,
      isUploading = _ref.isUploading,
      checkHipaa = _ref.checkHipaa,
      disabled = _ref.disabled,
      onCancel = _ref.onCancel,
      onImageClick = _ref.onImageClick,
      onDownload = _ref.onDownload,
      disabledRipple = _ref.disabledRipple;

  // If the attachment is an image, start with displaying a loader
  var _useState = useState(isImage(fileMeta.type || '')),
      _useState2 = _slicedToArray(_useState, 2),
      isImagePreviewLoading = _useState2[0],
      setIsImagePreviewLoading = _useState2[1];

  var handleImageLoaded = function handleImageLoaded() {
    return setIsImagePreviewLoading(false);
  };

  var cancelUpload = function cancelUpload() {
    if (!isUploading) return;
    onCancel && onCancel(fileMeta);
  };

  var downloadFile = function downloadFile() {
    onDownload && onDownload(fileMeta);
  };

  var handleImageClick = function handleImageClick() {
    onImageClick && onImageClick(fileMeta);
  };

  var isAttachmentImage = isImage(fileMeta.type || '');
  var onClickHandler = checkHipaa(downloadFile);
  var title = TEXT.DOWNLOAD_TITLE;

  if (isAttachmentImage && onImageClick) {
    onClickHandler = handleImageClick;
    title = TEXT.IMAGE_CLICK_TITLE;
  }

  if (isUploading) {
    onClickHandler = cancelUpload;
    title = TEXT.CANCEL_UPLOAD_TITLE;
  }

  return React.createElement(Wrapper, {
    isDocument: !isAttachmentImage,
    onClick: onClickHandler,
    title: title,
    disabled: disabled,
    disabledRipple: disabledRipple
  }, isAttachmentImage ? React.createElement(Image, {
    src: fileMeta.uri || "".concat(fileMeta.url, "?thumb=small"),
    alt: fileMeta.name,
    onLoad: handleImageLoaded,
    onError: handleImageLoaded
  }) : React.createElement(React.Fragment, null, React.createElement(FileIconWrapper, null, React.createElement(FileIcon, {
    mimeType: fileMeta.type,
    size: 44
  })), React.createElement(Title, null, fileMeta.name), React.createElement(Subtext, {
    secondary: true
  }, parseFileSize(fileMeta.size))), React.createElement(LoaderWrapper, {
    visible: isUploading || isImagePreviewLoading
  }, React.createElement(Loader, null), isUploading && React.createElement(CancelIconWrapper, null, React.createElement(Icon, {
    name: "close"
  }))));
});